import { BOOKSHOP_PACK } from "./bookshop";
import { ELECTRONICS_PACK } from "./electronics";
import { FASHION_PACK } from "./fashion";
import { PHARMACY_PACK } from "./pharmacy";
import { RETAIL_PACK } from "./retail";
import type { PackDef } from "./types";
import { WHOLESALE_PACK } from "./wholesale";

export * from "./overrides";
export * from "./types";
export {
  BOOKSHOP_PACK,
  ELECTRONICS_PACK,
  FASHION_PACK,
  PHARMACY_PACK,
  RETAIL_PACK,
  WHOLESALE_PACK,
};

/** Packs shown in onboarding, in display order. Unreleased verticals are listed as coming soon. */
export const PACKS: readonly PackDef[] = [
  RETAIL_PACK,
  PHARMACY_PACK,
  WHOLESALE_PACK,
  FASHION_PACK,
  ELECTRONICS_PACK,
  BOOKSHOP_PACK,
];

export const UPCOMING_PACKS: readonly {
  id: string;
  name: { en: string; bn: string };
  icon: string;
}[] = [];

export function getPack(id: string): PackDef | undefined {
  return PACKS.find((p) => p.id === id && p.available);
}

/** Every pack in code, whether or not onboarding offers it now. */
export function packById(id: string): PackDef | undefined {
  return PACKS.find((p) => p.id === id);
}
